let ReactDOMPromise;
if (process.env.HAS_REACT_DOM_CLIENT) {
  ReactDOMPromise = import('react-dom/client');
} else {
  ReactDOMPromise = import('react-dom');
}
function renderReactElement(element, root) {
  ReactDOMPromise.then((ReactDOM) => {
    if ("createRoot" in ReactDOM) {
      ReactDOM.createRoot(root).render(element);
    } else {
      ReactDOM.render(element, root);
    }
  });
}

export { renderReactElement };
//# sourceMappingURL=renderReactElement.esm.js.map
